import {
  adminCreateTeacherProfile,
  getPendingTeachers,
  approveTeacher,
  rejectTeacher,
  getAllReviews,
  getReviewById,
  getReviewsByTeacherProfileId,
  createReviews,
  updateReview,
  deleteReview,
  getAllRecommendations,
  getRecommendationById,
  getRecommendationsByTeacherProfileId,
  createRecommendations,
  updateRecommendation,
  deleteRecommendation,
  adminUpdateTeacherProfile,
  getAdminStats,
} from '../api/admin.api';

// Stats
export const adminGetStats = async () => {
  const res = await getAdminStats();
  return res.data;
};

// Teachers
export const adminCreateProfile = async (data) => {
  const res = await adminCreateTeacherProfile(data);
  return res.data;
};

export const adminUpdateProfile = async (id, data) => {
  const res = await adminUpdateTeacherProfile(id, data);
  return res.data;
};

export const adminGetPendingTeachers = async () => {
  const res = await getPendingTeachers();
  return res.data;
};

export const adminApproveTeacher = async (id) => {
  const res = await approveTeacher(id);
  return res.data;
};

export const adminRejectTeacher = async (id) => {
  const res = await rejectTeacher(id);
  return res.data;
};

// Reviews
export const adminGetAllReviews = async () => {
  const res = await getAllReviews();
  return res.data;
};

export const adminGetReviewById = async (id) => {
  const res = await getReviewById(id);
  return res.data;
};

export const getReviewsByProfileId = async (id) => {
  const res = await getReviewsByTeacherProfileId(id);
  return res.data;
};

export const adminCreateReviews = async (data) => {
  const res = await createReviews(data);
  return res.data;
};

export const adminUpdateReview = async (id, data) => {
  const res = await updateReview(id, data);
  return res.data;
};

export const adminDeleteReview = async (id) => {
  const res = await deleteReview(id);
  return res.data;
};

// Recommendations
export const adminGetAllRecommendations = async () => {
  const res = await getAllRecommendations();
  return res.data;
};

export const adminGetRecommendationById = async (id) => {
  const res = await getRecommendationById(id);
  return res.data;
};

export const getRecommendationsByProfileId = async (id) => {
  const res = await getRecommendationsByTeacherProfileId(id);
  return res.data;
};

export const adminCreateRecommendations = async (data) => {
  const res = await createRecommendations(data);
  return res.data;
};

export const adminUpdateRecommendation = async (id, data) => {
  const res = await updateRecommendation(id, data);
  return res.data;
};

export const adminDeleteRecommendation = async (id) => {
  const res = await deleteRecommendation(id);
  return res.data;
};
